





























































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Landing extends Vue {
  numEtains = 156;
  numCases = 95;
  numAreas = 50;
  numCountries = 4;
  onClickSteemit() {
    console.log("etain steemit");
  }
}
